/* eslint-disable react/button-has-type */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { BUDGET_ICONS } from '../../config/text/text';
import { getCountryCurrency } from '../../helpers/currency';
import { budgetIconFilters } from '../../helpers/giftfinder';
import ThemeContext from '../../providers/ThemeProvider';

export const BudgetFilters = ({
  updateFilter,
  sliderValues,
  setSliderValues,
  checkedState,
  setCheckedState,
}) => {
  const theme = useContext(ThemeContext);
  const lowArray = [0, 1, 2, 3, 4];
  const uppArray = [1, 2, 3, 4, 5];
  const currency = getCountryCurrency();

  const handleSelect = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : false,
    );
    setCheckedState(updatedCheckedState);

    if (updatedCheckedState[position] === true) {
      setSliderValues([lowArray[position], uppArray[position]]);
    } else {
      setSliderValues([0, 100]);
    }
  };

  useEffect(() => {
    updateFilter(sliderValues, checkedState.includes(true));
  }, [checkedState]);

  return (
    <>
      <div className="budget">
        <div className="budget-text">{BUDGET_ICONS}</div>
        <div className="price-filter">
          {budgetIconFilters.map((value, id) => (
            <button
              className={classNames(
                id !== 4
                  ? checkedState[id]
                    ? 'selectedButton'
                    : 'button'
                  : checkedState[id]
                  ? 'selectedlargeButton'
                  : 'largebutton',
              )}
              key={`budget-${id}`}
              onClick={() => handleSelect(id)}
            >
              {id !== budgetIconFilters.length - 1
                ? currency +
                  value +
                  ' - ' +
                  currency +
                  budgetIconFilters[id + 1]
                : currency + value + ' +'}
            </button>
          ))}
        </div>
      </div>
      <style jsx>{`
        .budget {
          padding-bottom: 25px;
        }
        .budget-text {
          font-weight: bold;
          padding-top: 5px;
          padding-bottom: 10px;
          font-size: 15px;
        }
        .price-filter {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .selectedButton,
        .selectedlargeButton {
          background-color: ${theme.colors.primary};
          border: 2px solid ${theme.colors.primary};
          color: ${theme.colors.background};
          text-align: center;
          display: inline-block;
          font-size: 14px;
          margin: 4px 2px;
          cursor: pointer;
          border-radius: 18px;
          width: 15%;
          padding: 5px;
        }
        .button,
        .largebutton {
          color: ${theme.colors.primary};
          border: 1px solid ${theme.colors.primary};
          background-color: ${theme.colors.background};
          text-align: center;
          display: inline-block;
          font-size: 15px;
          margin: 4px 2px;
          cursor: pointer;
          padding: 5px;
          border-radius: 18px;
          width: 15%;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .price-filter {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          }
          .selectedButton {
            background-color: ${theme.colors.primary};
            border: 2px solid ${theme.colors.primary};
            color: ${theme.colors.background};
            text-align: center;
            font-size: 14px;
            display: inline-block;
            border-radius: 20px;
            margin: 4px 2px;
            width: 48%;
            padding: 7px;
          }
          .largebutton {
            color: ${theme.colors.primary};
            border: 1px solid ${theme.colors.primary};
            background-color: ${theme.colors.background};
            text-align: center;
            display: inline-block;
            font-size: 14px;
            margin: 4px 2px;
            cursor: pointer;
            border-radius: 20px;
            width: 100%;
            padding: 7px;
          }
          .selectedlargeButton {
            background-color: ${theme.colors.primary};
            border: 2px solid ${theme.colors.primary};
            color: ${theme.colors.background};
            text-align: center;
            font-size: 14px;
            display: inline-block;
            border-radius: 20px;
            margin: 4px 2px;
            width: 100%;
            padding: 7px;
          }
          .button {
            color: ${theme.colors.primary};
            border: 1px solid ${theme.colors.primary};
            background-color: ${theme.colors.background};
            text-align: center;
            display: inline-block;
            font-size: 14px;
            margin: 4px 2px;
            cursor: pointer;
            border-radius: 20px;
            width: 48%;
            padding: 7px;
          }
        }
      `}</style>
    </>
  );
};

BudgetFilters.propTypes = {
  checkedState: PropTypes.array,
  setCheckedState: PropTypes.func,
  setSliderValues: PropTypes.func,
  sliderValues: PropTypes.array,
  updateFilter: PropTypes.func,
};
